import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.ash,
  textColorDark: colors.ash,
  textColorLight: colors.white,
  notFullBleed: true,
  notFullBleedBgColor: colors.alabaster
};
export default fiftyFiftyCard;